import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SoffApiResponseDto, SoffApiService } from '@soff/shared-ui';
import { environment } from 'src/environments/environment';
import { LogMessageTypeEnum } from '../models/log-message.model';

@Injectable({
  providedIn: 'root',
})
export class LogMessagesService {
  private api = inject(SoffApiService);

  private readonly baseUrl = environment.apiBaseUrl + '/v1/fieldservice/log-messages';

  loadLogMessages(
    rsqlFilter: string | null,
    filterValues: Record<string, string[]>,
    offset: number,
    pageSize: number,
    sortColumn: string | null,
    sortDirection: string | null
  ): Observable<SoffApiResponseDto> {
    const workshopId = filterValues['workshopId']?.[0];
    const logMessageType = filterValues['logMessageType']?.[0];
    const text = filterValues['text']?.[0];

    let url = this.baseUrl + '/' + workshopId;

    if (logMessageType === LogMessageTypeEnum.DmsInbound.toString()) {
      url += '/inbound';
    } else {
      url += '/outbound';
    }

    url += '?limit=' + pageSize + '&offset=' + offset;

    if (rsqlFilter) {
      url += '&filter=' + rsqlFilter;
    }

    if (sortColumn && sortDirection) {
      url += '&orderBy=' + sortColumn + ':' + sortDirection;
    }

    if (text?.length) {
      url += '&searchTerm=' + text;
    }

    return this.api.get(url).pipe(map(resp => resp.body));
  }
}
